import React, { useContext, useState } from 'react';
import '../Questions/styles/SingleOptionMedia.scss';
import { layoutContext } from '../RAIAssessment';
import PublicImage from 'src/common/components/PublicImage';
import { useEffect } from 'react';

interface singleOptionMediaProps {
  question: any;
}

const SingleOptionMedia = (sOMProps: singleOptionMediaProps) => {
  const { question } = sOMProps;
  const { options } = question;
  const {
    setSelectedOption,
    answers,
    setAnswers,
    questionId,
    setSelectedItems,
    selectedItems,
  } = useContext(layoutContext);

  const [selectedRadio, setSelectedRadio] = useState(-1);

  useEffect(() => {
    const index = question.id as keyof typeof answers;

    if (answers[index] || answers[index] === 0) {
      setSelectedRadio(answers[index]);
    }
  }, [questionId]);

  const handleOptionChange = (item: any, index: number) => {
    setSelectedItems({
      ...selectedItems,
      [questionId]: item,
    }),
      setSelectedRadio(index);
    setSelectedOption(item);
    setAnswers({ ...answers, [question.id]: index });
  };

  return (
    <div className="rai-assessment__single-option-media-container">
      {options.map((option: any, i: number) => (
        <div
          key={option.id}
          className={`rai-assessment__single-option-media ${
            selectedRadio === i
              ? 'rai-assessment__single-option-media-selected'
              : ''
          }`}
          onClick={() => handleOptionChange(option, i)}
        >
          <PublicImage
            imgPath={
              selectedRadio === i ? option.imageSelected : option.imageSrc
            }
            widgetId="rai-assessment"
            alt={'test'}
            className="rai-assessment__single-option-media-image"
          />
          <input
            type="radio"
            name="options"
            checked={answers[question.id as keyof typeof answers] === i}
            onChange={() => handleOptionChange(option, i)}
            className="rai-assessment__single-option-media-input"
          />
          <div className="rai-assessment__single-option-media-text">
            {option.text}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SingleOptionMedia;
